$(document).ready(function(){
  $('.guides-slider-main-block').slick({
  dots: false,
  infinite: true,
  speed: 700,
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow: "<button class='prev-arrow-guides guides-arrow'><img src='https://cdn.shopify.com/s/files/1/0602/4907/9992/files/Vector_35.svg' alt='icon'/></button>",
  nextArrow: "<button class='next-arrow-guides guides-arrow'><img src='https://cdn.shopify.com/s/files/1/0602/4907/9992/files/Vector_36.svg' alt='icon'/></button>",
  responsive: [
    {
      breakpoint: 749,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 589,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

  $('.review-slider-main-block').slick({
  dots: false,
  infinite: true,
  speed: 700,
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow: "<button class='prev-arrow-guides guides-arrow'><img src='https://cdn.shopify.com/s/files/1/0602/4907/9992/files/black-arrow-left.svg' alt='icon'/></button>",
  nextArrow: "<button class='next-arrow-guides guides-arrow'><img src='https://cdn.shopify.com/s/files/1/0602/4907/9992/files/black-arrow-right.svg' alt='icon'/></button>",
  responsive: [
    {
      breakpoint: 749,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 589,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
  // $('.short-description-faq').on('click',function(){
  //   $(this).find('.short-description-content').slideToggle();
  //   $(this).find('svg').toggleClass('short-description-icon-active');
  // });
});

$(document).on('click','.how-it-works-btn a', function(event){
  var scrollid = $(this).attr('href');
    event.preventDefault();
    $('html, body').animate({
      scrollTop: $(scrollid).offset().top - 100
    }); 
});
setTimeout(function () {
  $('.acquisition-product-section').hide().first().show();
}, 1000);
$('.stick-selector__option').click(function () {
  var productID = $(this).data('stick-product-id');
  $('.stick-selector__option').removeClass('active');
  $(`div[data-stick-product-id="${productID}"]`).addClass('active');

  $('.acquisition-product-section').hide();
  $(`div[data-product-id="${productID}"].acquisition-product-section`).show();

  $('.size-option.essential').removeClass('option-active');
  $(`div[data-product-id="${productID}"].acquisition-product-section div[data-stick-product-id="${productID}"].size-option.essential`).addClass('option-active');
  window.dispatchEvent(new Event('resize'));
});

$('.size-option').click(function () {
  var productID = $(this).data('stick-product-id');
  $('.size-option.essential').removeClass('option-active');
  $(`div[data-stick-product-id="${productID}"]`).addClass('option-active');

  $('.acquisition-product-section').hide();
  $(`div[data-product-id="${productID}"].acquisition-product-section`).show();
  window.dispatchEvent(new Event('resize'));
});
$(document).ready(function() {
$('.scroll-on-product-box').on('click', function(event) {
  event.preventDefault(); 
  const targetOffset = $('#metafield-product-box-element').offset().top - 100; 
  $('html, body').animate({
      scrollTop: targetOffset 
  }, 600); 
});
$('.scroll-on-lp-carousel').on('click', function(event) {
  event.preventDefault(); 
  const targetOffset = $('#lp-carousel-scroll-id').offset().top - 100; 
  $('html, body').animate({
      scrollTop: targetOffset 
  }, 600); 
});
});